module.exports = __webpack_public_path__ + "img/stop-1.40336a81.jpg";